import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../auth/AuthContext';
import '../global.css';
import { fetchWithAuth } from '../utils/fetchWithAuth';

const CreatePlayerPage = () => {
  const { token } = useContext(AuthContext);
  const navigate = useNavigate();

  const [playerName, setPlayerName] = useState('');
  const [playerPosition, setPlayerPosition] = useState('');
  const [playerHeight, setPlayerHeight] = useState('');
  const [jumpHeight, setJumpHeight] = useState('');
  const [spikeHeight, setSpikeHeight] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const validateForm = () => {
    if (playerName.length > 100) {
      alert("Name must be 100 characters or fewer.");
      return false;
    }

    if (!["Middle Blocker", "Setter", "Outside Hitter", "Libero", "Opposite"].includes(playerPosition)) {
      alert("Please select a valid position.");
      return false;
    }

    const shirtNum = parseInt(jumpHeight);
    if (isNaN(shirtNum) || shirtNum < 1 || shirtNum >= 100) {
      alert("Shirt number must be between 1 and 99.");
      return false;
    }

    const heightVal = parseInt(playerHeight);
    if (isNaN(heightVal) || heightVal <= 100 || heightVal >= 250) {
      alert("Height must be between 101 and 249 cm.");
      return false;
    }

    const spikeVal = parseInt(spikeHeight);
    if (isNaN(spikeVal) || spikeVal < 100) {
      alert("Spike height must be at least 100 cm.");
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    const confirmed = window.confirm("Are you sure you want to create this player?");
    if (!confirmed) return;

    const payload = {
      name: playerName,
      email,
      password,
      position: playerPosition,
      shirtNumber: jumpHeight,
      height: playerHeight,
      spikeHeight,
      blockHeight: 0
    };

    try {
      const res = await fetch('https://vballbackend.onrender.com/api/player/create', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(payload)
      });

      if (res.status === 401) {
        alert("Unauthorized. Please log in again.");
        return;
      }

      if (res.status === 409) {
        alert("Email already exists.");
        return;
      }

      if (!res.ok) {
        const err = await res.json();
        alert(`Failed: ${err.msg}`);
        return;
      }

      alert("Player created successfully!");
      navigate('/players');
    } catch (err) {
      console.error("Error creating player:", err);
      alert("Something went wrong.");
    }
  };

  return (
    <div className="container" style={{ maxWidth: '500px', marginTop: '3rem' }}>
      <div className="card">
        <h2 className="mb-4">Create a New Player</h2>
        <form onSubmit={handleSubmit} className="flex-col" style={{ gap: '1rem' }}>
          <input
            type="text"
            placeholder="Name"
            value={playerName}
            onChange={(e) => setPlayerName(e.target.value)}
            maxLength={100}
            required
          />

          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <input
            type="password"
            placeholder="Temporary Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <select
            value={playerPosition}
            onChange={(e) => setPlayerPosition(e.target.value)}
            required
          >
            <option value="">Select Position</option>
            <option value="Middle Blocker">Middle Blocker</option>
            <option value="Setter">Setter</option>
            <option value="Outside Hitter">Outside Hitter</option>
            <option value="Libero">Libero</option>
            <option value="Opposite">Opposite</option>
          </select>

          <input
            type="number"
            placeholder="Shirt Number"
            value={jumpHeight}
            onChange={(e) => setJumpHeight(e.target.value)}
            required
          />

          <input
            type="number"
            placeholder="Height (cm)"
            value={playerHeight}
            onChange={(e) => setPlayerHeight(e.target.value)}
            required
          />

          <input
            type="number"
            placeholder="Spike Height (cm)"
            value={spikeHeight}
            onChange={(e) => setSpikeHeight(e.target.value)}
            required
          />

          <button type="submit" className="btn-primary mt-2">
            Create Player
          </button>
        </form>
      </div>
    </div>
  );
};

export default CreatePlayerPage;
